import React from 'react';
import clsx from "clsx";

const Pagination = (
  { pages, currentPage, handleChangePage }:
  { pages?: Array<number>; currentPage?: number; handleChangePage: (page: number) => void; }
) => {

  return (
    <ul className="flex items-center gap-3 mt-10">
      {
        pages?.map(i => (
          <li
            onClick={() => handleChangePage(i)}
            className={
              clsx(
                "flex items-center justify-center w-8 h-8 border cursor-pointer hover:bg-gray duration-150 rounded ease-in",
                currentPage === i && "bg-gray"
              )
            }
            key={i}
          >{i}</li>
        ))
      }
    </ul>
  )
};

export default Pagination;
